<script>
export default {
    head() {
        return {
            templateParams: {
                tab: this.selectedTab?.title
            },
            titleTemplate: '%s %separator %tab'
        }
    },
    data() {
        return {
            hint: {
                show: false,
                left: false,
                right: true
            }
        }
    },
    props: {
        tabs: {
            type: Array,
            require: true
        },
        route: {
            type: String,
            require: true
        },
        via: {
            type: String,
            default: 'via-bhav-cool-gray-50'
        },
        to: {
            type: String,
            default: 'to-bhav-cool-gray-50'
        }
    },
    computed: {
        selectedTab() {
            return this.tabs.find(tab => tab.name === this.$route.params?.tab) || this.tabs[0];
        }
    },
    watch: {
        selectedTab: {
            handler(newTab) {
                this.$emit('tab-change', newTab.name);
            },
            immediate: true
        }
    },
    methods: {
        setScroller() {
            const tabs = this.$refs?.tabs;
            if (!tabs) return;

            const scrollLeft = tabs.scrollLeft;
            const scrollWidth = tabs.scrollWidth;
            const clientWidth = tabs.clientWidth;
            const maxScroll = scrollWidth - clientWidth;

            const threshold = 5;

            this.hint = {
                show: scrollWidth > clientWidth,
                left: scrollLeft > threshold,
                right: scrollLeft < maxScroll - threshold
            }
        }
    },
    created() {
        window.addEventListener('resize', this.setScroller);
        this.$nextTick(() => {
            this.$refs.tabs.addEventListener('scroll', this.setScroller)
            this.setScroller();
        });
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.setScroller);
        this.$refs.tabs.removeEventListener('scroll', this.setScroller)
    },
}
</script>

<style>
.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>

<template>
    <div class="flex flex-col">
        <nav role="tablist" class="relative border-b-2 border-bhav-blue-50" ref="tabwrapper">
            <ul class="flex -mb-[2px] gap-5 sm:gap-6 overflow-x-auto no-scrollbar" ref="tabs">
                <li :aria-controls="`panel-${tab.name}`" v-for="tab, i in tabs" :key="`panel-${i}`">
                    <component :is="selectedTab?.name === tab.name ? 'p' : 'router-link'" 
                    :class="selectedTab?.name === tab.name ? 'cursor-default border-bhav-blue-500 border-b-2 text-bhav-blue-500' : 'cursor-pointer text-bhav-blue-200 hover:text-bhav-blue-500 border-transparent hover:border-bhav-blue-500'"
                    class="group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none"
                    :to="{name: this.route, params: {tab: tab?.name}}">
                        <span v-if="tab?.icon" class="mr-2 text-lg" :class="(tab.prefixIcon ?? 'fak') + ' ' + tab.icon"></span>
                        <span class="hidden sm:inline whitespace-nowrap">{{ tab?.title }}</span>
                    </component>
                </li>
            </ul>
            <div aria-hidden="true" :class="[hint.show && hint.left ? `w-12` : 'w-0', `${via} ${to}`]" class="absolute top-0 left-0 bottom-0 z-10 from-transparent from-0% via-50% bg-gradient-to-l pointer-events-none transition-all duration-150">
            </div>
            <div aria-hidden="true" :class="[hint.show && hint.right ? `w-12` : 'w-0', `${via} ${to}`]" class="absolute top-0 right-0 bottom-0 z-10 from-transparent from-0% via-50% bg-gradient-to-r pointer-events-none transition-all duration-150">
            </div>
        </nav>            
        <slot name="buttons" />
        <section :id="`panel-${selectedTab?.name}`" role="tabpanel">
            <slot :tab="selectedTab"></slot>
        </section>
    </div>
</template>